import React, { useEffect, useContext, useState } from "react";
import "./Home.scss";
import Banner from "./Banner/Banner";
import Category from "./Category/Category";
import Products from "../Products/Products";
import { fetchDataFromApi } from "../../utils/api";
import { Context } from "../../utils/context";
import { AiFillCheckCircle } from "react-icons/ai";
// import Audi from "../../assets/car-logo/audi.jpeg";
import Toyota from "../../assets/car-logo/toyota.png";
import Bmw from "../../assets/car-logo/bmw.png";
import Byd from "../../assets/car-logo/byd.png";
import Cherolet from "../../assets/car-logo/chevrolet.png";
import Citreon from "../../assets/car-logo/citreon.png";
import Datsun from "../../assets/car-logo/datsun.png";
import Fiat from "../../assets/car-logo/fiat.png";
import Force from "../../assets/car-logo/force.png";
import Hm from "../../assets/car-logo/hm.png";
import Honda from "../../assets/car-logo/honda.png";
import Isuzu from "../../assets/car-logo/isuzu.png";
import Jeep from "../../assets/car-logo/jeep.png";
import Kia from "../../assets/car-logo/kia.png";
import LandoRover from "../../assets/car-logo/land-rover.png";
import Maruti from "../../assets/car-logo/maruti.png";
import Mercedes from "../../assets/car-logo/mercedes.png";
import Mg from "../../assets/car-logo/mg.png";
import Mini from "../../assets/car-logo/mini.png";
import Mitsubisi from "../../assets/car-logo/mitsubisi.png";
import Renault from "../../assets/car-logo/renault.png";
import Skoda from "../../assets/car-logo/skoda.png";
import Tata from "../../assets/car-logo/tata.png";
import Volkswagan from "../../assets/car-logo/volkswagan.png";
import Volvo from "../../assets/car-logo/volvo.png";
import { useNavigate } from "react-router-dom";
import hero from "../../assets/bike-logo/hero.png";
import bajaj from "../../assets/bike-logo/bajaj.png";
import honda from "../../assets/bike-logo/honda.png";
import royal from "../../assets/bike-logo/royal.png";
import ktm from "../../assets/bike-logo/ktm.png";
import tvs from "../../assets/bike-logo/tvs.png";
import yamaha from "../../assets/bike-logo/yamaha.png";
import mahindra from "../../assets/bike-logo/mahindra.png";
import suzuki from "../../assets/bike-logo/suzuki.png";

const Home = () => {
  const {
    products,
    setProducts,
    categories,
    setCategories,
    banner,
    setBanner,
    banner2,
    setBanner2,
    homeproduct,
    setHomeproduct,
    orderRoutes,
    setorderRoutes,
  } = useContext(Context);

  useEffect(() => {
    setorderRoutes(false);
    gethomeposter();
    getProducts();
    getCategories();
    getBanner();
    getBanner2();
    gethomeproduct();
  }, [orderRoutes]);
  const navigate = useNavigate();

  const [top, setTop] = useState("");
  const [mid, setMid] = useState("");
  const [bottom, setBottom] = useState("");

  const gethomeproduct = () => {
    fetchDataFromApi("/homeproduct/all").then((res) => {
      setHomeproduct(res);
    });
  };
  const gethomeposter = () => {
    fetchDataFromApi("/poster/position/top").then((res) => {
      setTop(res);
    });
    fetchDataFromApi("/poster/position/mid").then((res) => {
      setMid(res);
    });
    fetchDataFromApi("/poster/position/bottom").then((res) => {
      setBottom(res);
    });
  };

  const getBanner = () => {
    fetchDataFromApi("/slide/all").then((res) => {
      setBanner(res);
    });
  };
  const getBanner2 = () => {
    fetchDataFromApi("/slide2/all").then((res) => {
      setBanner2(res);
    });
  };
  const getProducts = () => {
    fetchDataFromApi("/show/all").then((res) => {
      setProducts(res);
    });
  };
  const getCategories = () => {
    fetchDataFromApi("/user/categories").then((res) => {
      setCategories(res);
    });
  };

  return (
    <div className=" w-screen overflow-hidden">
      <div className=" hidden md:block">
        <Banner Banner={banner} />
      </div>
      <div className=" md:hidden block">
        <Banner Banner={banner2} />
      </div>
      <div className="main-conten w-screen ">
        <div className="layout w-[95%] md:w-[80%] mx-auto">
          <Category categories={categories} />
          <Products
            headingText={homeproduct[0]?.heading}
            // headingText="New Arrival"
            products={products}
          />
          <Products
            headingText={homeproduct[1]?.heading}
            // headingText="New Arrival"
            products={products}
          />
          <div className=" grid md:grid-cols-3 gap-4">
            <img src={top[0]?.images} alt="" />
            <img src={top[1]?.images} alt="" />
            <img src={top[2]?.images} alt="" />
          </div>
          <Products
            headingText={homeproduct[2]?.heading}
            // headingText="New Arrival"
            products={products}
          />
          <Products
            headingText={homeproduct[3]?.heading}
            // headingText="New Arrival"
            products={products}
          />
        </div>
      </div>
      <div className=" hidden md:block">
        <img src={mid[0]?.images} alt="" />
      </div>
      <div className=" md:hidden block">
        <img src={mid[1]?.images} alt="" />
      </div>
      <div className=" pt-10">
        <h1
          style={{
            marginBottom: "30px",
            textAlign: "center",
            zIndex: "10",
          }}
          className="  relative z-50 py-2"
        >
          <h1 className=" absolute inset-0 flex items-center justify-center  -top-8 text-[3rem] md:text-[5rem]  font-thin z-0 text-[#E8E8E8]  ">
            PRODUCT
          </h1>
          <h1 className=" absolute inset-0 flex items-center justify-center    top-3 text-[1.3rem] md:text-[2.1rem] font-bold z-0 text-[#C51414] ">
            Search Car Accessories by Brand
          </h1>
        </h1>

        <div className="  grid     grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-9 w-[80%] mx-auto gap-10 my-10">
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/audi")}
          >
            <img
              src="https://www.carlogos.org/car-logos/audi-logo.png"
              alt=""
            />{" "}
            Audi
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/bmw")}
          >
            <img src={Bmw} alt="" /> BMW
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/byd")}
          >
            <img src={Byd} alt="" /> BYD
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/chevrolet")}
          >
            <img src={Cherolet} alt="" />
            Chevrolet
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/citeron")}
          >
            <img src={Citreon} alt="" />
            Citeron
          </div>

          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/datsun")}
          >
            <img src={Datsun} alt="" /> Datsun
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/fiat")}
          >
            <img src={Fiat} alt="" /> Fiat
          </div>
          {/* <div className=" text-center cursor-pointer font-bold" onClick={()=>navigate("category/force")}><img src={Force} alt="" /> Force</div> */}
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/ford")}
          >
            <img
              src="https://www.carlogos.org/car-logos/ford-logo.png"
              alt=""
            />{" "}
            Ford
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/hm")}
          >
            <img src={Hm} alt="" /> HM
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/honda")}
          >
            <img src={Honda} alt="" /> Honda
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/isuzu")}
          >
            <img src={Isuzu} alt="" /> Isuzu
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/jeep")}
          >
            <img src={Jeep} alt="" /> Jeep
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/kia")}
          >
            <img src={Kia} alt="" /> kia
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/mahindra")}
          >
            <img
              src="https://www.carlogos.org/car-logos/mahindra-logo.png"
              alt=""
            />{" "}
            Mahindra
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/maruti")}
          >
            <img src={Maruti} alt="" /> Maruti
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/mercedes")}
          >
            <img src={Mercedes} alt="" /> Mercedes
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/mg")}
          >
            <img src={Mg} alt="" /> MG
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/mini")}
          >
            <img src={Mini} alt="" /> Mini
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/mitsubisi")}
          >
            <img src={Mitsubisi} alt="" /> Mitsubishi
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/nissan")}
          >
            <img
              src="https://www.carlogos.org/car-logos/nissan-logo.png"
              alt=""
            />{" "}
            Nissan
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/land-rover")}
          >
            <img src={LandoRover} alt="" /> Land Rover
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/renault")}
          >
            <img src={Renault} alt="" /> Renault
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/skoda")}
          >
            <img src={Skoda} alt="" /> Skoda
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/tata")}
          >
            <img src={Tata} alt="" /> Tata
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/toyota")}
          >
            <img src={Toyota} alt="" /> Toyota
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/volkswagen")}
          >
            <img src={Volkswagan} alt="" /> Volkswagen
          </div>
          <div
            className=" text-center cursor-pointer font-bold"
            onClick={() => navigate("category/volvo")}
          >
            <img src={Volvo} alt="" /> Volvo
          </div>
        </div>
      </div>
      <div className=" pt-3">
        <h1
          style={{
            marginTop: "30px",
            marginBottom: "30px",
            textAlign: "center",
            zIndex: "10",
          }}
          className="  relative z-50 py-2"
        >
          <h1 className=" absolute inset-0 flex items-center justify-center  -top-8 text-[3rem] md:text-[5rem]  font-thin z-0 text-[#E8E8E8]  ">
            PRODUCT
          </h1>
          <h1 className=" absolute inset-0 flex items-center justify-center    top-3 text-[1.3rem] md:text-[2.1rem] font-bold z-0 text-[#C51414] ">
            Search Bike Accessories by Brand
          </h1>
          .
        </h1>
        <div className="  w-[80%]  space-y-10 mx-auto gap-10 my-10">
          <div className=" grid  grid-cols-5">
            {" "}
            <div
              className=" text-center cursor-pointer font-bold "
              onClick={() => navigate("category/hero")}
            >
              <img className=" object-cover" src={hero} alt="" /> Hero
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/honda")}
            >
              <img className="  object-cover" src={honda} alt="" />
              Honda
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/royal-enfield")}
            >
              <img className=" object-cover" src={royal} alt="" />
              Royal Enfield{" "}
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/bajaj")}
            >
              <img className=" object-cover" src={bajaj} alt="" />
              Bajaj{" "}
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/tvs")}
            >
              <img className="object-cover" src={tvs} alt="" />
              TVS{" "}
            </div>
          </div>
          <div className=" grid grid-cols-4 overflow-hidden   justify-center  w-[80%] mx-auto ">
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/ktm")}
            >
              <img className="   object-cover" src={ktm} alt="" />
              KTM{" "}
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/ktm")}
            >
              <img className="  object-cover" src={suzuki} alt="" />
              Suzuki{" "}
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/ktm")}
            >
              <img className="  object-cover" src={mahindra} alt="" />
              Mahindra{" "}
            </div>
            <div
              className=" text-center cursor-pointer font-bold"
              onClick={() => navigate("category/ktm")}
            >
              <img className="  object-cover" src={yamaha} alt="" />
              Yamaha{" "}
            </div>
          </div>
        </div>
      </div>
      <div className=" grid md:grid-cols-3 gap-4 w-[90%] md:w-[80%] mx-auto">
        <img src={bottom[0]?.images} alt="" />
        <img src={bottom[1]?.images} alt="" />
        <img src={bottom[2]?.images} alt="" />
      </div>
      <div>
        <p className="my-10  w-[80%] mx-auto  text-justify  leading-loose">
          CYNOR INDIA, since its inception, has been focused on delivering the
          best and most high-quality auto accessories to Indian automobile
          buyers at affordable prices. The company started its online operations
          in 2018 in India. Over the years, with consistent efforts and hard
          work, it has now become a household name and set a benchmark in the
          auto industry.. Our collection at CYNOR INDIA offers a set of premium
          products to make sure you and your vehicle are safe and maintained
          round the clock, in all types of conditions. At CYNOR INDIA, we are
          committed to offering technology-driven auto accessories, each
          designed and engineered to bring an optimum amount of comfort,
          convenience and luxury that serve the customers in the best way
          possible. Our team consistently keeps an eye on new trends to foster
          improvements in our products, in order to give the highest amount of
          satisfaction to the customers with a futuristic range of new car
          accessories. With the widest array of best car accessories including
          premium car safety devices, car care accessories, car styling
          accessories, followed by premium bike accessories, we are consistently
          dedicated to leaving no stone unturned to meet all the expectations of
          our customers. While our legacy in the market and the kind of customer
          relationships we build give us an upper hand, in the end, we pride
          ourselves on these top core features that are associated with our
          range of products. High quality auto accessories at best prices 100%
          customer satisfaction Hassle-free online shopping experience At
          CARIZO, our commitment to delivering top-tier auto accessories to
          Indian automobile buyers has been unwavering since our establishment
          in 2018. We've set a benchmark in the industry by providing quality
          products at affordable prices, all while ensuring an effortless online
          shopping experience. Our Core Features: Premium Auto Accessories at
          Competitive Prices, Guaranteed 100% Customer Satisfaction, Simplified
          Online Shopping, Our expansive collection includes premium car safety
          devices, car care accessories, and car styling accessories, along with
          a range of premium bike accessories. We leave no stone unturned to
          meet and exceed our customers' expectations. While our longstanding
          presence in the market and strong customer relationships give us an
          edge, our core features define us: Uncompromising Quality Auto
          Accessories, Assured Customer Satisfaction, Convenient Online Shopping
          Choose CARIZO for an elevated driving experience. Upgrade your vehicle
          with the best in auto accessories. Elevate Your Drive with carizo.in
        </p>
      </div>
    </div>
  );
};

export default Home;
